import angular from 'angular';
import * as R from 'ramda';
import ISharedModelService from './ISharedModel.service';


export class ecatSharedModelService extends ISharedModelService {
  constructor(
    $q
  ) {
    super('ecat');
    /**
     * Assessment object definition
     * @typedef {Object} assessment
     * @property {int} assessmentId
     * @property {string} completeDate
     * @property {string} completedUserName
     * @property {string} createDate
     * @property {string} createdUserName
     * @property {string} deleteDate
     * @property {string} name
     * @property {string} status
     */

    /**
     * Template object definition
     * @typedef {Object} template
     * @property {Boolean} isActive
     */

    /**
     * @deprecated Use get method that returns a promise instead (may need to implement)
     */
    this.templates = null;
    /**
     * @deprecated Use get method that returns a promise instead (may need to implement)
     */
    this.dfdGetTemplates = $q.defer();
     /**
     * @deprecated Use get method that returns a promise instead (may need to implement)
     */
     this.dfdGetInit = $q.defer();
    /**
     * @deprecated Use get method that returns a promise instead (may need to implement)
     */
    this.assessments = null;
    /**
     * @deprecated Use get method that returns a promise instead (may need to implement)
     */
    this.dfdGetAssessments = $q.defer();
    /**
     * @deprecated Use get method that returns a promise instead (may need to implement)
     */
    this.dfdGetUser = $q.defer();
    /**
     * @deprecated Use get method that returns a promise instead (may need to implement)
     */
    this.resumeAssessmentPromptDialog = null;
    /**
     * @deprecated Use get method that returns a promise instead (may need to implement)
     */
    this.confirmCompleteAssessmentDialog = null;
    /**
     * @deprecated Use get method that returns a promise instead (may need to implement)
     */
    this.editSettingsDialog = null;

    console.log('app.services.ecatSharedModelService created');
  }

  /**
   *
   * @param {Array} templates - Templates to be filtered
   * @return {Array<template>} - An array of active templates
   */
  getActiveTemplate(templates) {
    return R.find(template => template.isActive, templates);
  }

  /**
   *
   * @param {Array} assessments - Assessments to be filtered
   * @return {Array<assessment>} - An array of open assessments
   */
  getOpenAssessment(assessments) {
    return R.find(assessment => !assessment.deleteDate && !assessment.completeDate, assessments);
  }
}

ecatSharedModelService.$inject = [
  '$q'
];

export default angular.module('app.services.ecatSharedModelService', [])
  .service('ecatSharedModelService', ecatSharedModelService)
  .name;
